"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ = require("../");
var _excluded = ["overlay", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Wether to make LoaderContainer position:absolute, with top 0 and left 0 */
  overlay: _propTypes["default"].bool,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
exports.propTypes = propTypes;
var LoaderFull = function LoaderFull(_ref) {
  var _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_.LoaderContainer, _extends({
    overlay: overlay,
    automationHook: (0, _automationHooks.getHook)(automationHook, "loader-container")
  }, rest), /*#__PURE__*/_react["default"].createElement(_.Loader, {
    automationHook: (0, _automationHooks.getHook)(automationHook, "loader")
  }));
};
LoaderFull.propTypes = propTypes;
var _default = LoaderFull;
exports["default"] = _default;